import React, { useMemo } from 'react';
import { GroupItem, SimpleItem, Label } from "devextreme-react/form";
import IUniteEquipmentType from "../../models/IUniteEquipmentType";
import useTypesEquipements from '../../components/selectbox/types-equipements';
import GestionAbstract from '../../components/forms/gestion-abstract';
import Guid from '../../models/Guid';
import IBaseModel from '../../models/IBaseModel';

interface IGestionTypesEquipementsProps {
  isModeSelection?: boolean;
}

class UniteEquipmentType extends IBaseModel implements IUniteEquipmentType {
  idUniteEquipmentType: Guid = Guid.empty;
  typeEquipement: number = 0;
  longueurTampon: number = 0;
}

export default function GestionTypesEquipements({ isModeSelection }: IGestionTypesEquipementsProps) {
  const { typeEquipementEditorOptions } = useTypesEquipements();

  const longueurTamponEditorOptions = useMemo(() => {
    return { min: 0, showSpinButtons: true, width: '9%' }
  }, []);
  const descriptionEditorOptions = useMemo(() => {
    return { maxLength: 200, width: '50%' }
  }, []);

  return (
    <GestionAbstract<IUniteEquipmentType>
      path="UniteEquipmentType"
      model={UniteEquipmentType}
      customFormItems={(selectedEquipement) => (
        <GroupItem>
          <SimpleItem key={"frm-description"} dataField={"description"} editorOptions={descriptionEditorOptions}>
            <Label text={"Description"} showColon={false} />
          </SimpleItem>
          <SimpleItem key={"frm-type-equipement"} dataField={"typeEquipement"} editorType={"dxSelectBox"} editorOptions={typeEquipementEditorOptions}>
            <Label text={"Type d'équipement"} />
          </SimpleItem>
          <SimpleItem key={"frm-longueur-tampon"} dataField={"longueurTampon"} editorType={"dxNumberBox"} editorOptions={longueurTamponEditorOptions}>
            <Label text={"Longueur tampon"} />
          </SimpleItem>
        </GroupItem>
      )}
    />
  );
}
